import { Link } from 'react-router-dom';
import Logo from './Logo';
import { IconClose } from '@/components/icons/MainIcons';
import ThemeBtn from '@/components/ui/ThemeBtn';
// import English from '@/assets/images/🇬🇧.png';
// import Arab from '@/assets/images/🇸🇦.png';
import Arrow from '@/assets/svg/arrow-down.svg';
import { useLocalizedPath } from '@/hooks/useLocalizedPath';

const SideMenu = ({
    isMenuOpen,
    toggleMenu,
    menuItems,
    toggleLanguage,
    language,
    isDropdownOpen,
    handleLanguageChange,
}: {
    isMenuOpen: boolean;
    isDropdownOpen: boolean;
    toggleMenu: () => void;
    menuItems: { path: string; label: string; icon?: string }[];
    toggleLanguage: () => void;
    language: string;
    handleLanguageChange: (lang: string) => void;
}) => {
    const { getLocalizedPath } = useLocalizedPath();
    if (!isMenuOpen) return null;

    return (
        <div className="fixed inset-0 z-50">
            <div className="absolute top-0 right-0 left-0 bottom-0 bg-black/20" onClick={toggleMenu}></div>
            <div className="absolute top-0 right-0 left-0 h-fit rounded-b-xl dark:bg-bg/80 backdrop-blur-lg z-1 w-full drop-shadow-sideMenu py-5 px-[40px]">
                <div className="flex justify-between items-center mb-8">
                    <Link to={getLocalizedPath('/')}>
                        <Logo className="w-[82px] dark:text-Grey20 text-bg-logo" />
                    </Link>
                    <button onClick={toggleMenu}>
                        <IconClose className="w-[24px] h-[24px] dark:text-Grey20 text-bg-logo" />
                    </button>
                </div>
                <ul className="flex flex-col gap-4">
                    {menuItems.map((item) => {
                        const localizedPath = item.path === '#' ? '#' : getLocalizedPath(item.path);
                        return (
                            <li key={item.path} className="text-[16px] font-medium">
                                {item.path === '#' ? (
                                    <span className="dark:text-white text-bg-gray">{item.label}</span>
                                ) : (
                                    <Link to={localizedPath} onClick={toggleMenu} className="dark:text-white text-bg-gray">
                                        {item.label}
                                    </Link>
                                )}
                            </li>
                        );
                    })}
                </ul>
                <div className="mainRounded px-6 py-[14px] cursor-pointer langBorder mt-4" onClick={toggleLanguage}>
                    <h2 className="xl:text-[16px] md:text-[14px] font-bold leading-3 mx-auto text-Grey40 flex items-center gap-2">
                        <img
                            loading="lazy"
                            src={language === 'ar' ? '/assets/sa.png' : '/assets/gb.png'}
                            alt={language === 'ar' ? 'العربية - Current Language' : 'English - Current Language'}
                            className="w-6 h-6"
                        />
                        <h2 className="md:text-[16px] text-[14px] font-bold leading-3 text-Grey20">
                            {language === 'ar' ? 'العربية' : 'English'}
                        </h2>
                        <img
                            loading="lazy"
                            src={Arrow}
                            alt="Language Dropdown Arrow"
                            className={`ml-2 transform transition-transform ${
                                isDropdownOpen ? 'rotate-180' : 'rotate-0'
                            }`}
                        />
                    </h2>
                </div>
                <div className="flex items-center justify-center mt-4">
                    <ThemeBtn />
                </div>
            </div>

            {isDropdownOpen && (
                <div className="absolute right-0 mt-2 headLinks shadow-md rounded-2xl py-2 px-6 z-50">
                    <button onClick={() => handleLanguageChange('en')} className="flex px-4 py-4 gap-2">
                        <span>
                            <img loading="lazy" src={'/assets/gb.png'} alt="English-icon" />
                        </span>
                        <div className="text-bg-gray dark:text-Grey20 md:text-[16px] text-[14px]">English</div>
                    </button>
                    <button className="flex px-4 py-4 gap-2" onClick={() => handleLanguageChange('ar')}>
                        <span>
                            <img loading="lazy" src={'/assets/sa.png'} alt="Arabic-icon" />
                        </span>
                        <div className="text-bg-gray dark:text-Grey20 md:text-[16px] text-[14px]">العربية</div>
                    </button>
                </div>
            )}
        </div>
    );
};

export default SideMenu;
